import { createContext } from "react";

export const isMobileContext = createContext(false);
export const isTabContext = createContext(false);